import { render, staticRenderFns } from "./lubrication.vue?vue&type=template&id=1aae5700&scoped=true"
import script from "./lubrication.vue?vue&type=script&lang=js"
export * from "./lubrication.vue?vue&type=script&lang=js"
import style0 from "./lubrication.vue?vue&type=style&index=0&id=1aae5700&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aae5700",
  null
  
)

export default component.exports